import { useState } from "react";
import { useDispatch } from "react-redux";
import SelectDefault from "@/src/components/SelectDefault/SelectDefault";
import VerticalLine from "@/src/components/VerticalLine/VerticalLine";
import { officeAccountingHeaderSelectConst } from "@/src/constants/officeAccountingTableConfig";
import { setActualOfficeTable } from "@/src/store/slices/OfficeAccountingPage/officeAccountingFiltersSlice";

const HeaderOfficeAccounting = () => {
  const dispatch = useDispatch();
  const [currentOfficeSelect, setCurrentOfficeSelect] = useState(officeAccountingHeaderSelectConst[0]?.id ?? "ALL");

  const handleOfficeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setCurrentOfficeSelect(event.target.value);
    dispatch(setActualOfficeTable(event.target.value));
  };

  return (
    <div className="header-office-accounting">
      <SelectDefault onChange={handleOfficeChange} value={currentOfficeSelect}>
        {officeAccountingHeaderSelectConst.map((item) => (
          <option value={item.id} key={item.id}>
            {item.title}
          </option>
        ))}
      </SelectDefault>
      {/* <VerticalLine /> */}
    </div>
  );
};

export default HeaderOfficeAccounting;
